import React from 'react';
import PropTypes from 'prop-types';

const BusinessPlanToolTip = (props) => {
  const stateObject = props.states[props.tooltipRegion];
  if (stateObject) {
    return (
      <div>
        <div className="business-map-tooltip-header" key={`${props.tooltipRegion}-header`}>
          <span className="state-name">
            {props.tooltipRegion.replace('-', ' ')}
          </span>
          <span className="state-rank">
            Rank: {stateObject.ranking}
          </span>
          <div className="clear-both" />
        </div>
        <div className="business-map-tooltip-content">
          <span className="content-description">
            Number of business plans created per 100,000 people
          </span>
          <span className="business-plan-number">
            {stateObject.business_plan_number}
          </span>
          <div className="clear-both" />
        </div>
      </div>
    );
  }

  return <div />;
};

BusinessPlanToolTip.defaultProps = {
  tooltipRegion: null,
};

BusinessPlanToolTip.propTypes = {
  tooltipRegion: PropTypes.string,
  states: PropTypes.shape({
  }).isRequired,
};

export default BusinessPlanToolTip;



// WEBPACK FOOTER //
// ./src-react/UsaMap/tooltips/BusinessPlanToolTip.jsx